export const ApiPostRequest = async(API_ENDPOINT, data = {}) => {
    const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(data),
    });

    if (response.ok) {
        return response.json();
    }

    // eslint-disable-next-line no-console
    console.log('AJAX Response: ');
    console.log(response);
    throw new Error('Something went wrong ...');
};
